import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// import theme from "./theme.js";
import Routes from "./Routes";

ReactDOM.render(
  // <ThemeProvider theme={theme}>
    <React.StrictMode>
      {/* <CssBaseline /> */}
      <Routes />
    </React.StrictMode>
  // </ThemeProvider>
  ,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
